import { gql } from "@apollo/client";

export default gql`
  mutation LeaveGroupAsVendor($groupId: ObjectId!) {
    leaveGroupAsVendor(groupId: $groupId)
  }
`;
